module.exports = __webpack_public_path__ + "static/img/materialsInfo13.f1054b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsInfo13.png
// module id = aA58
// module chunks = 2